import React from 'react'

import imgBG from "../../assets/imagens/bg_decklist.jpg";
const CardList = () => {
    return (
        <div style={{ backgroundImage: `url(${imgBG})`, }} className='h-full w-full bg-cover bg-center flex justify-center md:justify-end items-cente overflow-hidden'>
            <div className={`mr-0 duration-200 bg-slate-700 bg-opacity-[94%] w-full h-full pt-16 transition-all  `}>
                lkjlkj                      g
            </div>
        </div>
    )
}

export default CardList